/**
 * @generated SignedSource<<88b377bc0d3bdad75b94ed1d973afec8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuySharedResultContainer_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuySharedItemTrackingProvider_viewer" | "SharedItemTile_viewer">;
  readonly " $fragmentType": "BuySharedResultContainer_viewer";
};
export type BuySharedResultContainer_viewer$key = {
  readonly " $data"?: BuySharedResultContainer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuySharedResultContainer_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedResultContainer_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuySharedItemTrackingProvider_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "36192dc76c72c705110b355c58c14da4";

export default node;
